import { Affix } from "antd"
import { Link } from "react-scroll";
import { homeNav } from "./homeNav";
import styles from './index.less';

export default () => {
  return (
    <Affix offsetTop={80}>
      <ul className={styles.nav}>
        {homeNav.map((item) => {
          return  <Link
            activeClass="active"
            spy={true}
            to={item.id}
            smooth={true}
            duration={500}
            offset={item.offset}>
              <li className={styles.li}>{item.name}</li>
            </Link>
        })}
      </ul>
    </Affix>
  )
}